import { map, range } from "lodash";
import { AiccFeedbackPostAction, AiccFeedbackType } from "types/model/aiccCustomer";
import { MAX_DOWNVOTE_TURN } from "types/transformers/aiccCustomer";
import { CHART_COLORS } from "./charts/chartTheme";

export const FEEDBACK_PAGE_LIMIT = 10;

export const MIN_DATE = "2026-08-01";

export const MAX_FLUENCY_LEVEL = 10;

export const POST_ACTION_LABEL: Record<AiccFeedbackPostAction, string> = {
  continued: "Continued (>5 rounds)",
  retried: "Retried (1–5 rounds)",
  rage_quit: "Rage-Quit (0 round)",
};

export const POST_ACTION_COLOR: Record<AiccFeedbackPostAction, string> = {
  continued: CHART_COLORS.continued,
  retried: CHART_COLORS.retried,
  rage_quit: CHART_COLORS.rageQuit,
};

export const FEEDBACK_TYPE_OPTIONS: { label: string; value: AiccFeedbackType }[] = [
  { label: "👍 Thumbs Up", value: "positive" },
  { label: "👎 Thumbs Down", value: "negative" },
];

export const DOWNVOTE_TURN_OPTIONS = map(range(1, MAX_DOWNVOTE_TURN + 1), (turn) => ({
  label: turn === MAX_DOWNVOTE_TURN ? `${MAX_DOWNVOTE_TURN}+` : String(turn),
  value: turn,
}));

export const POST_ACTION_OPTIONS: { label: string; value: AiccFeedbackPostAction }[] = [
  { label: POST_ACTION_LABEL.continued, value: "continued" },
  { label: POST_ACTION_LABEL.retried, value: "retried" },
  { label: POST_ACTION_LABEL.rage_quit, value: "rage_quit" },
];

export const FLUENCY_LEVEL_OPTIONS = map(range(1, MAX_FLUENCY_LEVEL + 1), (level) => ({
  label: String(level),
  value: level,
}));
